/** Shopify CDN: Minification failed

Line 17:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 28:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 37:2 Transforming const to the configured target environment ("es5") is not supported yet
Line 38:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 39:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 40:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 41:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 42:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 43:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 44:4 Transforming const to the configured target environment ("es5") is not supported yet
... and 23 more hidden warnings

**/
(function () {
  const accordionHeader = $('[data-accordion-toggle]'),
    accordionBody = $('[data-accordion-body]'),
    selectedColor = $('[data-selected-color]'),
    selectedMount = $('[data-selected-mount]'),
    selectedSize = $('[data-selected-size]'),
    selectedLift = $('[data-selected-lift]'),
    selectedRoll = $('[data-selected-roll]'),
    selectedCassette = $('[data-selected-cassette]'),
    nextStep = $('[data-next-step]');

  accordionHeader.click(function () {
    const _this = $(this);
    toggleHeader(_this);
    accordionHeaderUpdates(_this);
  });

  nextStep.click(function () {
    openNextOption($(this));
  });

  const openNextOption = (_this) => {
    const curHeader = _this.parent().prev();
    const nextHeader = _this.parent().parent().next();
    const selectedOption = $('.custom-configurator-image-select-item-active');
    const width = $('#select-width-id option:selected').text();
    const subWidth = $('#select-sub-width-id option:selected').text();
    const height = $('#select-length-id option:selected').text();
    const subHeight = $('#select-sub-length-id option:selected').text();

    toggleOptions(_this, curHeader, nextHeader);
    displaySelectedOption(_this, curHeader, selectedOption, width, subWidth, height, subHeight);
  }

  const toggleOptions = (_this, curHeader, nextHeader) => {
    // close current option
    _this.closest(accordionBody).css('display', 'none');
    curHeader.removeClass('is-open');
    curHeader.addClass('selected-step');
    // open next option
    toggleNextOption(curHeader, nextHeader);
  }

  const toggleNextOption = (curHeader, nextHeader) => {
    const curHeaderText = curHeader[0].innerText;

    if (curHeaderText.includes('Color')) {
      const mount = nextHeader.parent().find('[data-selected-mount]').parent();
      mount[0].classList.add('is-open');
      mount.next()[0].style.display = 'block';
    } else if (curHeaderText.includes('Size')) {
      const lift = nextHeader.parent().find('[data-selected-lift]').parent();
      lift[0].classList.add('is-open');
      lift.next()[0].style.display = 'block';
     } else {
      nextHeader.find(accordionHeader)[0].classList.add('is-open');
      nextHeader.find(accordionBody)[0].style.display = 'block';
    }
  }

  const displaySelectedOption = (_this, curHeader, selectedOption, width, subWidth, height, subHeight) => {
    const curText = curHeader[0].innerText;

    if (curText.includes('Color')) {
      selectColor(selectedOption)
      resetMountPosition()
    } else if (curText.includes('Mount')) {
      selectMount(selectedOption)
      resetSizePosition()
    } else if (curText.includes('Size')) {
      selectSize(width, subWidth, height, subHeight)
      resetLiftPosition()
    } else if (curText.includes('Lift')) {
      selectLift(selectedOption)
      resetRollPosition()
    } else if (curText.includes('Roll')) {
      selectRoll(selectedOption)
      resetCassettePosition()
    } else if (curText.includes('Cassette')) {
      selectCassette(selectedOption)
      resetWindowDescriptionPosition()
    }
  }

  const resetMountPosition = () => {
    $('html, body').animate({
      scrollTop: $('.custom-configurator-right-wrapper').offset().top + 80
    }, 'slow');
  }
  const resetSizePosition = () => {
    $('html, body').animate({
      scrollTop: $('.custom-configurator-right-wrapper').offset().top + 150
    }, 'slow');
  }
  const resetLiftPosition = () => {
    $('html, body').animate({
      scrollTop: $('.custom-configurator-right-wrapper').offset().top + 210
    }, 'slow');
  }
  const resetRollPosition = () => {
    $('html, body').animate({
      scrollTop: $('.custom-configurator-right-wrapper').offset().top + 280
    }, 'slow');
  }
  const resetCassettePosition = () => {
    $('html, body').animate({
      scrollTop: $('.custom-configurator-right-wrapper').offset().top + 340
    }, 'slow');
  }
  const resetWindowDescriptionPosition = () => {
    $('html, body').animate({
      scrollTop: $('.custom-configurator-right-wrapper').offset().top + 400
    }, 'slow');
  }
  
  const toggleHeader = (_this) => {
    if (_this[0].className.includes('is-open')) {
      _this.removeClass('is-open');
      _this.next().css("display", "none");
    } else {
      accordionHeader.removeClass('is-open');
      accordionHeader.next().css("display", "none");
      _this.addClass('is-open');
      _this.next().css("display", "block");
    }
  }

  const accordionHeaderUpdates = (_this) => {
    const optionTitle = _this[0].innerText;
    const selectedOption = $('.custom-configurator-image-select-item-active');
    const width = $('#select-width-id option:selected').text();
    const subWidth = $('#select-sub-width-id option:selected').text();
    const height = $('#select-length-id option:selected').text();
    const subHeight = $('#select-sub-length-id option:selected').text();

    selectAccordion(optionTitle, selectedOption, width, subWidth, height, subHeight, _this);
  }

  const selectAccordion = (optionTitle, selectedOption, width, subWidth, height, subHeight, _this) => {
    if (_this[0].className.includes('is-open')) {
      _this.addClass('selected-step');
      if (optionTitle.includes('Color')) {
        selectColor(selectedOption);
      } else if (optionTitle.includes('Mount')) {
        selectColor(selectedOption);
        selectMount(selectedOption);
      } else if (optionTitle.includes('Size')) {
        selectMount(selectedOption);
        selectSize(width, subWidth, height, subHeight);
      } else if (optionTitle.includes('Lift')) {
        selectSize(width, subWidth, height, subHeight);
        selectLift(selectedOption);
      } else if (optionTitle.includes('Roll')) {
        selectLift(selectedOption);
        selectRoll(selectedOption);
      } else if (optionTitle.includes('Cassette')) {
        selectRoll(selectedOption);
        selectCassette(selectedOption);
      } else {
        selectCassette(selectedOption);
      }
    }
  }

  const selectColor = (option) => selectedColor.text(`: ${option[0].dataset.imageSelectItem}`);
  const selectMount = (option) => selectedMount.text(`: ${option[1].dataset.imageSelectItem}`);
  const selectSize = (width, subWidth, height, subHeight) => selectedSize.text(`: ${width}" ${subWidth} W x ${height}" ${subHeight} L`);
  const selectLift = (option) => selectedLift.text(`: ${option[2].dataset.imageSelectItem}`);
  const selectRoll = (option) => selectedRoll.text(`: ${option[3].dataset.imageSelectItem}`);
  const selectCassette = (option) => selectedCassette.text(`: ${option[4].dataset.imageSelectItem}`);

})();